module.exports = __webpack_public_path__ + "assets/img/ZT.b666062a.png";